import AbstractEntity from "./abstractEntity";

/*
divisionObj properties:
  - abbr
  - colors
  - id
  - league (id)
  - name
  - seasons ({season: divisionSeasonId})
 */
class Division extends AbstractEntity {
  /**
   *
   * @param {object} divisionObj
   * @param {UserInfo} userInfo
   */
  // constructor(divisionObj, userInfo) {
  //   super(divisionObj, userInfo);
  // }

  /**
   *
   * @returns {object}
   */
  getLeagueObj() {
    return this.userInfo.getLeagueObj(this.obj.league);
  }

  /**
   *
   * @param {number|string} season
   * @returns {object}
   */
  getDivisionSeasonObj(season) {
    this._verifyKeyExists(this.obj.seasons, season, "division.seasons");
    return this.userInfo.getDivisionSeasonObj(this.obj.seasons[season]);
  }
}

export default Division;
